import AppLoader from './AppLoader';

const FullScreenLoader: React.FC = () => {
    return (
        <div className="w-full h-full flex justify-center items-center">
            <AppLoader />
        </div>
    );
};

export default FullScreenLoader;
